<template>
  <Wrapper>
    <CommonHowToJoin></CommonHowToJoin>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/pc/Wrapper";
import CommonHowToJoin from "../../../components/pc/howtojoin/CommonHowToJoin";
export default {
  components: {
    Wrapper,
    CommonHowToJoin,
  },
  name: "HowToJoin",
};
</script>



// WEBPACK FOOTER //
// src/pages/pc/howtojoin/HowToJoin.vue